module.exports = __webpack_public_path__ + "omniv2/img/icon-tick.c0ed610b.svg";